import React from "react";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { Box, Typography } from "@mui/material";
import { alertStyles } from "../../../../assets/MUIStyles/commonStyles";

const NoticeAlert = ({ title = "", content = "", variant = "warning" }) => {
  const bannerbackground =
    variant === "warning" ? "#FFF7E6" : variant === "info" ? "#F0FAFF" : "";
  const borderColor =
    variant === "warning" ? "#FFC233" : variant === "info" ? "#00ACFF" : "";
  const textColor =
    variant === "warning" ? "#8A6100" : variant === "info" ? "#0075AD" : "";

  return (
    <Box
      sx={{
        ...alertStyles.container,
        backgroundColor: bannerbackground,
        borderLeft: `2px solid ${borderColor}`,
      }}
    >
      <Box sx={alertStyles.innerContainer}>
        <InfoIcon
          height={20}
          width={20}
          fill={borderColor}
          className="info-icon"
        />
      </Box>
      <Box>
        {title && (
          <Typography
            className="font-14-500"
            sx={{
              color: textColor,
              marginBottom: 1,
            }}
          >
            {title}
          </Typography>
        )}
        {content && (
          <Typography
            className="font-14-400"
            sx={{
              color: textColor,
            }}
          >
            {content}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NoticeAlert;
